/**
 * LensToggle — switches the time-metric definition (the point of the tool:
 * compare what "time spent" means under different lenses). Pure client-side;
 * never refetches.
 */

import SegmentedControl from '../../ui/SegmentedControl';
import { TimeLens, LENS_LABELS } from '../types';

interface LensToggleProps {
  lens: TimeLens;
  onChange: (lens: TimeLens) => void;
}

const LENS_TITLES: Record<TimeLens, string> = {
  with_crc: 'Only minutes the patient was with the coordinator',
  ready_crc: 'Roomed-and-waiting time plus with-coordinator time',
  whole_visit: 'Everything from check-in to check-out',
  breakdown: 'All statuses, shown stacked',
};

export function LensToggle({ lens, onChange }: LensToggleProps) {
  return (
    <SegmentedControl
      label="Time lens"
      value={lens}
      onChange={(v) => onChange(v as TimeLens)}
      options={(Object.keys(LENS_LABELS) as TimeLens[]).map((key) => ({
        value: key,
        label: LENS_LABELS[key],
        title: LENS_TITLES[key],
      }))}
    />
  );
}

export default LensToggle;
